module.exports = __webpack_public_path__ + "static/changwon.lee-0ad1a6955a539e30f03c07fc34819ac3.jpeg";